// using strings instead of numbers to simplify usage as object keys, to avoid
// casting a string (after Object.keys for example) to a number
enum FieldCategory {
  GENERAL = 'general',
  ADDRESS = 'address',
  CUSTOM = 'custom',
}

export default FieldCategory;
